"use client";

import * as React from "react";
import { DayPicker } from "react-day-picker";
import { ru } from "date-fns/locale";
import { IconChevronLeft, IconChevronRight } from "@/components/ui/icons";
import { cn } from "@/lib/cn";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

export function Calendar({ className, classNames, showOutsideDays = true, ...props }: CalendarProps) {
  return (
    <DayPicker
      locale={ru}
      weekStartsOn={1}
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        months: "flex flex-col sm:flex-row gap-4",
        month: "flex flex-col gap-3",
        month_caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-[12px] font-semibold text-[var(--text)]",
        nav: "flex items-center gap-1 absolute right-0 top-0 z-10",
        button_previous: "inline-flex h-[30px] w-[30px] items-center justify-center rounded-[var(--radius-md)] transition glass-hover text-[var(--textMuted)] hover:text-[var(--text)] hover:bg-[var(--hover)]",
        button_next: "inline-flex h-[30px] w-[30px] items-center justify-center rounded-[var(--radius-md)] transition glass-hover text-[var(--textMuted)] hover:text-[var(--text)] hover:bg-[var(--hover)]",
        month_grid: "w-full border-collapse",
        weekdays: "flex",
        weekday: "flex h-7 w-8 items-center justify-center text-[11px] font-semibold text-[var(--textMuted)]",
        weeks: "",
        week: "flex w-full mt-0.5",
        day: "flex h-8 w-8 items-center justify-center p-0 text-[12px]",
        day_button:
          "h-8 w-8 rounded-full text-[12px] transition outline-none focus:ring-2 focus:ring-[var(--primary)]/30 hover:bg-[var(--hover)]",
        selected:
          "[&_button]:bg-[var(--primary)] [&_button]:text-[var(--primaryText)] [&_button]:font-semibold [&_button:hover]:bg-[var(--primary)]",
        today: "[&:not(.selected)_button]:text-[#f97316] [&:not(.selected)_button]:font-semibold",
        outside: "[&_button]:text-[var(--textMuted)] [&_button]:opacity-50",
        disabled: "[&_button]:opacity-30 [&_button]:cursor-not-allowed",
        range_start: "[&_button]:rounded-r-none",
        range_end: "[&_button]:rounded-l-none",
        range_middle:
          "[&_button]:rounded-none [&_button]:bg-[var(--secondary)] [&_button]:text-[var(--secondaryText)] [&_button:hover]:bg-[var(--secondary)]",
        hidden: "invisible",
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation, ...rest }) => {
          const Icon = orientation === "left" ? IconChevronLeft : IconChevronRight;
          return <Icon size={14} {...rest} />;
        },
      }}
      {...props}
    />
  );
}
